import React from 'react';
import './RedBingoCard.css';

class BingoCard extends React.Component {

  get freeSpace(){
    return(
      <div className={`freespace ${this.props.cardColor === 'red' ? 'red-freespace' : ''}`} style={{ position: 'relative' }}>
        {this.props.cardColor === 'red' ? <img src="/images/image.png" alt="Crown" style={{ 
          width: '80px', 
          height: '100px',
          position: 'absolute',
          top: '-10px',
          left: '2px',
          zIndex: 1,
      
        }} /> : (
          <>
            <span>Free</span><span>Space</span>
          </>
        )}
      </div>
    )
  }
  
  
  render(){
    let card = this.props.card;
    
    return(
      
      <div className="row">
        {Object.keys(card).map((letter) => (
       
            <div className="col" key={"let" + letter}>
              {this.props.cardColor === 'red' ? null : (
                <div style={{
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginBottom: '10px'
                }}>Bingo-Lottery</div>
              )}
              <div className={`card-letter ${this.props.cardColor === 'red' ? 'red-card-letter' : ''}`} style={{
                color: this.props.cardColor === 'red' ? '#000000' : '',
                fontSize: this.props.cardColor === 'red' ? '80px' : '',
                fontWeight: this.props.cardColor === 'red' ? 'bold' : ''
              }}>{letter}</div>
              {this.props.cardColor === 'red' && (
                <div className="card-id" style={{
                  position: 'absolute',
                  bottom: '-30px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  fontSize: '120px',
                  color: '#000000',
                  zIndex: 2
                }}>Card {this.props.card.id}</div>
              )}
              <div className={`card-numbers ${this.props.cardColor === 'red' ? 'red-card-numbers' : ''}`}>
                {Object.values(card[letter]).map((number, index) => (
                  <div className={`card-number ${this.props.cardColor === 'red' ? 'red-card-number' : ''}`} key={letter + number}>
                      {letter === "N" && index === 2 ? this.freeSpace :number}
                  </div>
                ))}
              </div>
              
            
            </div>
          )
        )}
       
        
      </div>
    
    )
   
  }


}
export default BingoCard;